<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BlogLinkList"
});
</script>

<template lang="pug">
  ul.list-unstyled
    li
      router-link(:to="{ name: 'unentdeckte-wellnessoasen-deutschland'}")
        font-awesome-icon(icon="link")
        |
        | Unentdeckte Wellnessoasen in Deutschland – Geheimtipps für Ihre Auszeit
    li
      router-link(:to="{ name: 'deutschland-staedtereisen-highlights'}")
        font-awesome-icon(icon="link")
        |
        | Städtetrips in Deutschland: Diese Städte sollte man gesehen haben
    li
      router-link(:to="{ name: 'maedelsurlaub-tipps-und-wellness'}")
        font-awesome-icon(icon="link")
        |
        | Der perfekte Mädelstrip – Wellness und Entspannung
    li
      router-link(:to="{ name: 'nordsee-ostsee'}")
        font-awesome-icon(icon="link")
        |
        | Nordsee oder Ostsee? Welches Meer passt besser zu Ihrem Urlaub?
    li
      router-link(:to="{ name: 'wellnessurlaub-jahreszeiten'}")
        font-awesome-icon(icon="link")
        |
        | Wellnessurlaub: Vor- und Nachteile der 4 Jahreszeiten
    li
      router-link(:to="{ name: 'staedtereisen-architektur'}")
        font-awesome-icon(icon="link")
        |
        | Städtereisen für Architektur- und Designliebhaber
    li
      router-link(:to="{ name: 'stressfreies-reisen'}")
        font-awesome-icon(icon="link")
        |
        | So gelingt der perfekte Kurzurlaub: Tipps für stressfreies Reisen
    li
      router-link(:to="{ name: 'last-minute-reiseziel'}")
        font-awesome-icon(icon="link")
        |
        | Last-Minute-Reiseziele für Kurzurlaube in Deutschland
    li
      router-link(:to="{ name: 'staedtetrip-wellness'}")
        font-awesome-icon(icon="link")
        |
        | Städtetrip und Wellness kombinieren: Die schönsten Destinationen
    li
      router-link(:to="{ name: 'wanderwege-deutschland'}")
        font-awesome-icon(icon="link")
        |
        | Die schönsten Wanderwege in Deutschland
</template>

<style scoped lang="scss">
@import "@/assets/styles/_colors.scss";
@import "@/assets/styles/mediaqueries.scss";
@import "@/assets/styles/blog.scss";

.check-icon {
  color: var(--theme-color-basic, $tdays-basic);
}
</style>
